module.exports = __webpack_public_path__ + "static/media/left-white.eb250f39.svg";